/**
 * What a checkout opens in the page, as one string: a LemonSqueezy checkout
 * URL for the iframe, or a Stripe Embedded Checkout's client secret behind
 * STRIPE_EMBED_PREFIX. Every flow keeps its `checkoutUrl` ref as before, and
 * components/common/CheckoutEmbed.vue shows whichever it is.
 */
export const STRIPE_EMBED_PREFIX = 'stripe-embedded:'

export function stripeEmbedSrc(clientSecret: string): string {
  return `${STRIPE_EMBED_PREFIX}${clientSecret}`
}

/** The client secret of a Stripe checkout, or null for a LemonSqueezy URL. */
export function stripeClientSecretOf(src: string | null | undefined): string | null {
  return src?.startsWith(STRIPE_EMBED_PREFIX) ? src.slice(STRIPE_EMBED_PREFIX.length) : null
}
